/** Copyright © 2024 Qcells. All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized use,
 * duplication, or distribution of software is strictly prohibited.
 */
import 'tui-grid/dist/tui-grid.css';
import '@vueform/slider/themes/default.css';
import '@hems/component/resources/vendor/css_new/common.css';
import '@hems/component/resources/vendor/css_new/common_style.css';
import '@hems/component/resources/vendor/css_new/main.css';
import '@hems/component/resources/vendor/css_new/contents.css';
import '@hems/component/resources/vendor/css_new2021/common_new2021.css';
import '@hems/component/resources/vendor/script/selecter/jquery.fs.selecter.css';
import '@hems/component/resources/styles/main.scss';
import '@/resources/styles/main.scss';
import '@imengyu/vue3-context-menu/lib/vue3-context-menu.css';
import 'vue3-date-time-picker/dist/main.css';
import 'vue-final-modal/dist/style.css';

import { createApp } from 'vue';
import { createVfm } from 'vue-final-modal';
import VuePinch from 'vue-pinch';

import ContextMenu from '@imengyu/vue3-context-menu';
import PrimeVue from 'primevue/config';
import VCalelar from 'v-calendar';

import App from '@hems/user/src/App.vue';
import router from '@hems/user/src/router';
import store from '@hems/user/src/stores';
import { AxiosPlugin, i18n, initYup } from '@hems/util';

initYup();

const vueFinalModal = createVfm();

createApp(App)
  .use(AxiosPlugin, {
    baseURL: process.env.VUE_APP_API_URL,
  })
  .use(store)
  .use(i18n)
  .use(VCalelar)
  .use(router)
  .use(VuePinch)
  .use(ContextMenu)
  .use(vueFinalModal)
  .use(PrimeVue, { unstyled: true })
  .mount('#app');
